function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56 0H0v56h56V0z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.603 16.252H11.667A4.68 4.68 0 0 0 7 20.919v25.62c0 .805.42 1.551 1.097 1.983.373.233.805.35 1.236.35.35 0 .7-.082 1.027-.233l12.822-6.254h11.445a4.68 4.68 0 0 0 4.666-4.666v-16.8a4.68 4.68 0 0 0-4.666-4.667h-.024zm0 17.243v4.224H22.622c-.35 0-.7.081-1.027.233l-9.94 4.853V20.92h22.948v12.576z",
  fill: "#0285C9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.695 11.667v2.356h4.667v-2.356h22.972v18.666h-2.8V35h2.8A4.68 4.68 0 0 0 49 30.333V11.667A4.68 4.68 0 0 0 44.334 7H21.362a4.68 4.68 0 0 0-4.667 4.667z",
  fill: "#0285C9"
});

var SvgQueriesAndComplaints = function SvgQueriesAndComplaints(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueriesAndComplaints, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queries_and_complaints.2a8dc53c.svg";
export { ForwardRef as ReactComponent };